import { useMemo, useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { addMonths, startOfMonth, endOfMonth, startOfWeek, addDays, format, isSameMonth } from "date-fns";
import { it } from "date-fns/locale";

const HEAD = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

export const CyclePreview = ({ slots }) => {
  const byDate = useMemo(() => {
    const m = {};
    (slots || []).forEach((s, i) => { if (s.data) (m[s.data] = m[s.data] || []).push({ ...s, n: i + 1 }); });
    return m;
  }, [slots]);
  const first = (slots || []).find((s) => s.data)?.data;
  const [month, setMonth] = useState(() => startOfMonth(first ? new Date(`${first}T00:00`) : new Date()));
  useEffect(() => { if (first) setMonth(startOfMonth(new Date(`${first}T00:00`))); }, [first]);

  const days = [];
  for (let d = startOfWeek(month, { weekStartsOn: 1 }); d <= endOfMonth(month) || days.length % 7; d = addDays(d, 1)) days.push(d);
  const inMonth = Object.keys(byDate).filter((k) => isSameMonth(new Date(`${k}T00:00`), month)).reduce((a, k) => a + byDate[k].length, 0);

  return (
    <div className="rounded-md border bg-white p-3" data-testid="cycle-preview">
      <div className="mb-2 flex items-center justify-between">
        <button type="button" onClick={() => setMonth((m) => addMonths(m, -1))} className="rounded p-1 hover:bg-slate-100" data-testid="cycle-preview-prev"><ChevronLeft className="h-4 w-4" /></button>
        <div className="text-center">
          <div className="text-sm font-semibold capitalize text-slate-800" data-testid="cycle-preview-month">{format(month, "MMMM yyyy", { locale: it })}</div>
          <div className="text-[11px] text-muted-foreground" data-testid="cycle-preview-count">{inMonth} sedute in questo mese · {(slots || []).length} totali</div>
        </div>
        <button type="button" onClick={() => setMonth((m) => addMonths(m, 1))} className="rounded p-1 hover:bg-slate-100" data-testid="cycle-preview-next"><ChevronRight className="h-4 w-4" /></button>
      </div>
      <div className="grid grid-cols-7 gap-1 text-center">
        {HEAD.map((h) => <div key={h} className="text-[10px] font-medium uppercase text-slate-400">{h}</div>)}
        {days.map((d) => {
          const key = format(d, "yyyy-MM-dd");
          const items = byDate[key];
          const out = !isSameMonth(d, month);
          return (
            <div key={key} title={items ? items.map((s) => `Seduta ${s.n}: ${s.ora_inizio}-${s.ora_fine}`).join("\n") : ""}
              data-testid={items ? `cycle-preview-day-${key}` : undefined}
              className={`flex h-10 flex-col items-center justify-center rounded text-xs ${out ? "text-slate-300" : "text-slate-600"} ${items ? "bg-primary font-semibold text-primary-foreground" : ""}`}>
              <span>{d.getDate()}</span>
              {items && <span className="text-[9px] leading-none opacity-90">{items[0].ora_inizio}</span>}
            </div>
          );
        })}
      </div>
    </div>
  );
};
